export const categoryValidationRules = (values) => {
  const errors = {};
  const namePattern = /^[A-Z_-]+$/;

  if (!values.name || values.name.trim() === "") errors.name = "Name is required";
  else if (values.name && values.name.length < 3) errors.name = "Name must be at least 3 characters";
  else if (values.name && values.name.length > 50) errors.name = "Name must be at most 50 characters";
  else if (values.name && !namePattern.test(values.name))
    errors.name = "Capital letters, underscores ( _ ) and hyphens (-) are allowed";

  return errors;
};
